import { useEffect, useState, useCallback, useRef } from 'react';

import { getCookie } from '@zooplus/commons-lang';

import { MOBILE_APP_COOKIE, PAYMENT_INCOMPLETE_MODAL_SHOW_TIMEOUT } from '@utilities/constants';

export const usePaymentIncompleteModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const timeoutId = useRef<ReturnType<typeof setTimeout>>();

  const showPaymentIncompletePopup = useCallback(() => {
    if (document.hidden) {
      timeoutId.current = setTimeout(() => {
        setIsModalOpen(true);
      }, PAYMENT_INCOMPLETE_MODAL_SHOW_TIMEOUT);
    }
  }, []);

  useEffect(() => {
    const isMobileApp = getCookie(MOBILE_APP_COOKIE);

    if (isMobileApp) {
      document.addEventListener('visibilitychange', showPaymentIncompletePopup);

      return () => {
        document.removeEventListener('visibilitychange', showPaymentIncompletePopup);
        if (timeoutId.current) {
          clearTimeout(timeoutId.current);
        }
      };
    }
    return undefined;
  }, [showPaymentIncompletePopup]);

  return { isModalOpen };
};
